import { observer } from "mobx-react";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import { Input } from "../../../../../../components/inputs/input/input";
import "./reserved-item-days-remaining-inputs.scss";
import { IValidationGroup } from "../../../../../../hooks/validation-group/validation-group-hook";
import { ReservedItemDaysRemainingStore } from "./reserved-item-days-remaining-store";
import { FONT_COLOR } from "../../../../../../components/fonts/font-props";

interface IProps {
    store: ReservedItemDaysRemainingStore;
    validationGroup: IValidationGroup;
}

const ReserverdItemsDaysRemainingInput: React.FC<IProps> = observer(({ store, validationGroup }) => (
    <div className="days-remaining-input-container">
        <div className="days-inputs-container">
            <Input
                value={store.from}
                onChange={(v) => {
                    store.setFrom(v); 
                    validationGroup.validate();
                }}
                type="number"
                min={0}
                validationGroup={validationGroup}
                validationCallback={store.validate}
            />
            <FontBody2>to</FontBody2>
            <Input
                value={store.to}
                onChange={(v) => {
                    store.setTo(v); 
                    validationGroup.validate();
                }}
                type="number"
                min={0}
                validationGroup={validationGroup}
                validationCallback={store.validate}
            />
        </div>
        {store.validationErrorMessages.map(message => (
            <FontBody2 key={message} color={FONT_COLOR.SEMANTIC_DANGER}>{message}</FontBody2>
        ))}
    </div>
));

export default ReserverdItemsDaysRemainingInput;
